import { Component, OnInit } from '@angular/core';
import { AdSpaceEnum, EditAdvertModel } from '../../../models/inModels/Advert';
import { Message } from "primeng/components/common/message";
import { SelectItem } from "primeng/components/common/selectitem";
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { AdvertService } from '../../../services/business/advert.service';
import { StorageService } from '../../../services/system/storage.service';

@Component({
	selector: 'app-adverts-edit',
	templateUrl: './adverts-edit.component.html',
	styleUrls: ['./adverts-edit.component.css']
})
export class AdvertsEditComponent implements OnInit {
	id;
	model: EditAdvertModel;
	loading = false;
	error: Message[];
	uploading = false;
	selectedAdvertType;
	advertTypeId: SelectItem[];
	adverts;

	AdSpaceEnum = AdSpaceEnum;
	AdSpaces: any[] = [
		{label: AdSpaceEnum[1], value: 1},
		{label: AdSpaceEnum[2], value: 2},
		{label: AdSpaceEnum[3], value: 3},
		{label: AdSpaceEnum[4], value: 4},
		{label: AdSpaceEnum[5], value: 5},
		{label: AdSpaceEnum[6], value: 6},
		{label: AdSpaceEnum[7], value: 7},
	]; 

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private service: AdvertService,
		private storageService: StorageService) {
		console.log(this.route.snapshot.paramMap.get('Id'));
		this.id = this.route.snapshot.paramMap.get('Id');
		
	}

	ngOnInit(): void {
		this.getAdvert();
	}

	getAdvert() {
		this.loading = true;
		this.service.get(this.id).then(
			result => {
				this.model = new EditAdvertModel(result);
				this.model.showInFeed = this.model.advertTypeId != 1;
				this.selectedAdvertType = {value: result.AdvertTypeId, label: result.AdvertType}
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	initAdvertTypeDropDown(event): void {
		this.service.getDropdownList(event).then(
			x => {
				this.adverts = x;
				console.log("Suggestion Model", x);
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	setAdvertType(): void {
		this.model.advertTypeId = this.selectedAdvertType.value;
	}

	goBack(): void {
		this.router.navigate(['/adverts']);
	}

	save() {
		this.loading = true;
		this.service.update(this.model).then(
			result => {
				this.loading = false;
				this.model = new EditAdvertModel(result);
				this.model.showInFeed = this.model.advertTypeId != 1;
				this.error = [];
				this.error.push({ severity: 'success', summary: 'Success', detail: "Event saved" });
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	handleImage(event): void {
		var result = this.storageService.handleSuccess(event);

		this.model.bannerId = result.PublicId;
		this.loading = false;
	}
	handleVideo(event): void {
		var result = this.storageService.handleSuccess(event);

		this.model.bannerId = result.PublicId;
		this.loading = false;
	}

	handleError(event): void {
		this.loading = false;
		this.error = [];
		this.storageService.handleError(event, this.error);
	}

	removeImage(): void {
		this.model.bannerId = null;
		this.loading = false;
	}

}



// WEBPACK FOOTER //
// ./src/app/components/adverts/adverts-edit/adverts-edit.component.ts